<template>
    <div>
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <h3>运输任务</h3>
            </div>
            <el-form ref="queryParamsRef" :model="queryParams" inline label-width="110px">
                <el-form-item label="订单编号" prop="orderNumber">
                    <el-input v-model="queryParams.orderNumber" clearable placeholder="请输入订单号" size="mini" style="width:200px" />
                </el-form-item>
                <el-form-item label="子订单编号">
                    <el-input v-model="queryParams.logisticSubTaskId" clearable placeholder="请输入子订单号" size="mini" style="width:200px" />
                </el-form-item>
                <el-form-item label="装货方" prop="fromMember">
                    <biz-select-async v-model="queryParams.fromMember" url="http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/queryFromMemberByName" :params="{ 'carrierId': queryParams.carrierMemberId }" size="mini" style="width:200px" />
                </el-form-item>
                <el-form-item label="卸货方" prop="toMember">
                    <!-- <plt-dict-select v-model="queryParams.toMember" placeholder="请选择卸货方" namespace="bizObjects" id="member" size="mini" /> -->
                    <biz-select-async v-model="queryParams.toMember" url="http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/queryToMemberByName" :params="{ 'carrierId': queryParams.carrierMemberId }" size="mini" style="width:200px" />
                </el-form-item>
                <el-form-item label="装货联系人" prop="linkman">
                    <el-input v-model="queryParams.linkman" placeholder="请输入联系人" clearable size="mini" style="width:200px" />
                </el-form-item>
                <el-form-item label="车牌号" prop="plateNumber">
                    <el-input v-model="queryParams.plateNumber" size="mini" placeholder="请输入车牌号" clearable style="width:200px" />
                </el-form-item>
                <el-form-item label="派单时间" prop="dispatcherTime">
                    <el-date-picker v-model="queryParams.dispatcherTime" type="date" style="width:200px" size="mini" clearable value-format="yyyy-MM-dd" placeholder="请选择派单时间" />
                </el-form-item>
                <el-form-item label="承运商备注" prop="carrierRemark">
                    <el-input v-model="queryParams.carrierRemark" size="mini" placeholder="请输入承运商备注" clearable style="width:200px" />
                </el-form-item>
                <el-form-item label="装货区域">
                    <plt-address-cascader v-model="queryParams.fromAreaId" size="mini" width="200" />
                </el-form-item>
                <el-form-item label="计划装货日期" prop="planDate">
                    <el-date-picker v-model="queryParams.planDate" type="date" style="width:200px" size="mini" clearable value-format="yyyy-MM-dd" placeholder="请选择计划装货日期" />
                    <el-button type="primary" @click="onQuery" size="mini" style="margin-left:10px">查询</el-button>
                    <el-button type="warning" @click="onClear" size="mini" style="margin-left:10px">重置</el-button>
                </el-form-item>
            </el-form>
            <table-title>
                <el-button @click="onExceptionFlag" :type="queryParams.exceptionFlag?'danger':''" size="mini" round style="margin-right:10px">异常标识</el-button>

                <span v-for="(item, index) in countList" :key="index" style="margin-right:10px">
                    <el-button size="mini" round @click="queryByStatus(item.status)" :type="(item.checked ? 'danger' : '')">
                        <plt-dict-box :value="item.status" namespace="logistic" id="logisticSubTaskProxyStatus" />
                        {{ item.quantity }}
                    </el-button>
                </span>
                <el-button type="success" @click="onExport" size="mini" :disabled="arrangeDriverList.length > 0 ? false : true">批量下载</el-button>
                <el-button type="warning" @click="onExportTask" size="mini">导出任务</el-button>
            </table-title>
            <plt-table ref="tableRef" :url="queryUrl" :queryParams="queryParams" paramName="params" :pageSize="50">
                <template #table="{ data }">
                    <el-table :data="data" border row-key="orderNumber" size="mini" ref="orderData" :tree-props="{ children: 'subTasks' }" max-height="650px" @selection-change="handleSelectionChange" :default-expand-all="true" class="order">
                        <el-table-column label="" type="selection" fixed="left" :width="25" :selectable="handleSelectable" />
                        <el-table-column type="index" :width="40" label="#" fixed="left">
                            <template slot-scope="scope">
                                <div v-if="scope.row.type">{{ data.indexOf(scope.row) + 1 }}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单号" prop="orderNumber" :width="130" fixed="left" />
                        <el-table-column label="子订单号" prop="logisticSubTaskId" :width="130" />

                        <el-table-column label="状态" :width="55">
                            <template #default="{ row }">
                                <el-tag v-if="row.status === 'to_arrange_driver'" type="danger" size="mini">待派车</el-tag>
                                <el-tag v-if="row.status === 'to_handover'" type="warning" size="mini">待交接</el-tag>
                                <el-tag v-if="row.status === 'handover'" type="primary" size="mini">已交接</el-tag>
                                <el-tag v-if="row.status === 'finish'" type="success" size="mini">已完成</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="异常标记" :width="55">
                            <template #default="{ row }">
                                <el-tag v-if="row.exceptionFlag" type="danger" size="mini">异常</el-tag>
                            </template>
                        </el-table-column>
                        <plt-table-dict-col label="装货方" prop="fromMemberId" namespace="bizObjects" id="member" />
                        <el-table-column label="实际装货方" prop="realFromMemberName" :width="140" />

                        <plt-table-dict-col label="装货区域" prop="fromAreaId" namespace="region" id="fullArea" :width="155" />
                        <el-table-column label="装货详细地址" :width="160">
                            <template #default="{ row }">
                                <template v-if="row.fromAddress">{{ row.fromAddress }}</template>
                                <template v-else>{{ row.fromAddr }}</template>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="装货详细地址" prop="fromAddress" :width="160" /> -->
                        <el-table-column label="装货联系人" :width="120">
                            <template #default="{ row }">
                                <span> {{ row.fromLinkmanName }} {{ row.fromLinkmanMobile }}</span>
                            </template>
                        </el-table-column>
                        <plt-table-dict-col label="卸货方" prop="toMemberId" namespace="bizObjects" id="member" />
                        <plt-table-dict-col label="卸货区域" prop="toAreaId" namespace="region" id="fullArea" :width="155" />
                        <el-table-column label="卸货详细地址" prop="toAddr" :width="160" />
                        <el-table-column label="卸货联系人" :width="120">
                            <template #default="{ row }">
                                <span> {{ row.toLinkmanName }} {{ row.toLinkmanMobile }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="产品名称">
                            <template #default="{ row }">
                                <template v-if="row.targetType">
                                    <plt-dict-box namespace="target" id="type" :value="row.targetType" />
                                </template>
                                <template v-else>{{ row.goodsName }}</template>
                            </template>
                        </el-table-column>
                        <!-- <plt-table-dict-col label="产品名称" prop="targetType" namespace="target" id="type" />
            <el-table-column label="货品名称" prop="goodsName" /> -->
                        <el-table-column label="数量" prop="planQty" :width="50" />
                        <el-table-column label="签收数量" prop="receiveQty" :width="50" />
                        <el-table-column label="发运日期" prop="planDate" :width="70" />
                        <plt-table-formatter-col label="派单时间" prop="dispatcherTime" formatter="datetime" :width="120" />
                        <plt-table-formatter-col label="预计上门日期" prop="expectedLoadDate" formatter="date" :width="80" />
                        <el-table-column label="备注" prop="remark" />
                        <el-table-column label="承运商备注" prop="carrierRemark" />
                        <el-table-column label="司机名称" prop="driverName" :width="55" />
                        <el-table-column label="车牌号" prop="plateNo" :width="75" />
                        <el-table-column label="操作" fixed="right" :width="120">
                            <template #default="{ row }">
                                <el-button type="text" @click="onDetail(row.logisticTaskId, 'logistics')" size="mini" v-if="row.type === 'logistics'">详情</el-button>
                                <el-button type="text" @click="onDetail(row.waybillId, 'waybill')" size="mini" v-if="row.type === 'waybill'">详情</el-button>
                                <el-button style="color:#67c23a" type="text" @click="onExportSingle(row)" size="mini" v-if="(row.goodsName && !row.subTasks && row.status !== 'to_arrange_driver' && row.driverName) || (row.bizType && row.bizType !== 'TERMINATE_START_RENT' && ((row.status !== 'to_arrange_driver' && row.driverName) || (queryParams.carrierMemberId == '3546' && row.bizType === 'TERMINATE_RENT')) && !row.subTasks)">签收单</el-button>
                                <template v-if="row.bizType && row.bizType === 'TERMINATE_START_RENT' && row.status !== 'to_arrange_driver' && !row.subTasks && row.driverName">
                                    <el-button type="text" style="color:#e6a23c" @click="onExportSingle(row, `装货单`)" size="mini">装货单</el-button>
                                    <el-button type="text" style="color:#e6a23c" @click="onExportSingle(row, `卸货单`)" size="mini">卸货单</el-button>
                                </template>
                            </template>
                        </el-table-column>
                    </el-table>
                </template>
            </plt-table>
        </el-card>
        <waybill-detail ref="waybillDetailRef" @onFinish="onFinish" />
        <exportTask ref="exportTaskRef" />
        <detail ref="detailRef" @onFinish="onFinish" />
    </div>
</template>

<script>
import detail from "./component/detail.vue";
import waybillDetail from "./component/waybill-detail.vue";
import exportTask from "./component/exportTask.vue";
import { Loading } from "element-ui";
export default {
    components: { waybillDetail, detail, exportTask },
    data() {
        return {
            queryUrl: "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/queryDispatchedTasks",
            queryParams: {
                carrierMemberId: sessionStorage.getItem("memberId"),
                orderNumber: "",
                fromMember: "",
                toMember: "",
                plateNumber: "",
                planDate: "",
                status: "",
                linkman: "",
                dispatcherTime: "",
                exceptionFlag: "",
                carrierRemark: "",
            },
            countList: [],
            arrangeDriverList: [],
        };
    },
    mounted() {
        this.queryCount();
    },
    methods: {
        onExceptionFlag(){
          this.queryParams.exceptionFlag = true;
          this.$refs["tableRef"].loadFirstPage();
        },
        queryCount() {
            let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyQueryService/queryDispatcherStatusCounting";
            this.countList = [];
            this.invoke(url, { carrierMemberId: sessionStorage.getItem("memberId") }).then((res) => {
                this.countList = [];
                res.forEach((ele) => {
                    this.countList.push({ ...ele, checked: false });
                });
            });
        },
        onQuery() {
            this.queryParams.status = "";
            if (!this.queryParams.planDate) this.queryParams.planDate = "";
            this.$refs["tableRef"].loadFirstPage();
            this.queryCount();
        },
        onClear() {
            this.queryParams.exceptionFlag = "";
            this.$refs["queryParamsRef"].resetFields();
            this.onQuery();
        },
        queryByStatus(status) {
            this.countList.forEach((ele) => {
                if (ele.status === status) {
                    ele.checked = true;
                } else {
                    ele.checked = false;
                }
            });
            this.queryParams.status = status;
            this.$refs["tableRef"].loadFirstPage();
        },
        // 多选框是否可勾选
        handleSelectable(row) {
            if (row.driverName && row.bizType && row.bizType !== "TERMINATE_START_RENT" && (row.status != "to_arrange_driver" || (this.queryParams.carrierMemberId == "3546" && row.bizType == "TERMINATE_RENT")) && !row.subTasks) {
                return 1;
            }
            if (row.driverName && row.bizType && row.bizType === "TERMINATE_START_RENT" && row.status != "to_arrange_driver" && !row.subTasks) {
                return 1;
            }
        },
        // 勾选数据
        handleSelectionChange(params) {
            this.arrangeDriverList = params
                .map((body) => {
                    let tmp = {
                        exportId: "",
                        param: { logisticSubTaskId: body.logisticSubTaskId },
                    };
                    if (body.bizType === "START_RENT") {
                        tmp.exportId = "startRentDoc";
                    } else if (body.bizType === "TERMINATE_RENT") {
                        tmp.exportId = "terminateRentDoc";
                        tmp.param.logisticTaskId = body.logisticTaskId;
                    } else if (body.bizType === "SALE") {
                        tmp.exportId = "tradeReceiveNote";
                    } else if (body.bizType === "ADJUST") {
                        tmp.exportId = "adjustDoc";
                    } else if (body.bizType === "TERMINATE_START_RENT") {
                        let terminateRentDoc = {
                            exportId: "terminateRentDoc",
                            param: { logisticSubTaskId: body.logisticSubTaskId, logisticTaskId: body.logisticTaskId },
                        };
                        let startRentDoc = {
                            exportId: "startRentDoc",
                            param: { logisticSubTaskId: body.logisticSubTaskId, logisticTaskId: body.logisticTaskId },
                        };
                        return [terminateRentDoc, startRentDoc];
                    }
                    return tmp;
                })
                .flat();
        },
        // 批量导出
        async onExport() {
            let exportList = JSON.parse(JSON.stringify(this.arrangeDriverList));
            let loadingInstance = Loading.service({ text: "签收单打包中..." });
            this.request("/export/batchExportPDF", { body: exportList }, { headers: { "Content-Type": "application/x-www-form-urlencoded", responseType: "arraybuffer" } })
                .then((rs) => {
                    const explorer = window.navigator.userAgent;
                    if (explorer.indexOf("Chrome") >= 0) {
                        var tempwindow = window.open("_blank");
                        tempwindow.location = `${rs}`;
                    } else {
                        let aTag = document.createElement("a");
                        aTag.download = "签收单.zip";
                        aTag.href = rs;
                        aTag.click();
                        URL.revokeObjectURL(aTag.href);
                    }
                    this.arrangeDriverList = [];
                    this.$refs["orderData"].clearSelection();
                    loadingInstance.close();
                })
                .finally(() => {
                    loadingInstance.close();
                    this.arrangeDriverList = [];
                    this.$refs["orderData"].clearSelection();
                });
        },
        onExportTask() {
            this.$refs["exportTaskRef"].openDialog();
        },
        // 导出单个签收单
        async onExportSingle(body, type = "") {
            let params = {
                body: { logisticSubTaskId: body.logisticSubTaskId },
            };
            if (body.bizType === "START_RENT") {
                params.exportId = "startRentDoc";
            } else if (body.bizType === "TERMINATE_RENT") {
                params.exportId = "terminateRentDoc";
                params.body.logisticTaskId = body.logisticTaskId;
            } else if (body.bizType === "SALE") {
                params.exportId = "tradeReceiveNote";
            } else if (body.bizType === "ADJUST" || body.goodsName) {
                params.exportId = "adjustDoc";
            } else if (type) {
                if (type === "装货单") {
                    params.exportId = "terminateRentDoc";
                    params.body.logisticTaskId = body.logisticTaskId;
                } else {
                    params.exportId = "startRentDoc";
                }
            }
            let loadingInstance = Loading.service({ text: "签收单处理中..." });
            await this.download("/exportPDF", params);

            loadingInstance.close();
            return true;
        },

        onFinish() {
            this.$refs["tableRef"].queryData();
            this.queryCount();
        },

        // 详情
        onDetail(id, type) {
            if (type === "logistics") this.$refs["waybillDetailRef"].openDialog(id);
            if (type === "waybill") this.$refs["detailRef"].openDialog(id);
        },
    },
};
</script>
<style lang="scss" scoped>
/deep/.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #c5c8ce !important;
}

/deep/.el-table--border,
.el-table--group {
    border-left: 1px solid #c5c8ce;
    border-top: 1px solid #c5c8ce;
    border-bottom: 1px solid #c5c8ce;
}

/deep/.el-table--border .el-table__cell,
.el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
    border-right: 1px solid #c5c8ce;
}

/deep/.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid #c5c8ce;
}

/deep/.el-textarea {
    vertical-align: middle;
}

/deep/.el-card__header {
    padding: 5px 20px;
}

/deep/.el-table .warning-row {
    background: #faecd8;
}

/deep/.el-table .success-row {
    background: #f0f9eb;
}

/deep/.el-table .danger-row {
    background: #fef0f0;
}

/deep/.el-table .cell {
    line-height: 14px;
}

/deep/.el-table--mini td,
.el-table--mini th {
    padding: 0 !important;
}

/deep/.el-card__body {
    padding: 0;
}

/deep/.el-form-item {
    margin: 5px 0 0 5px;
}

.el-table .DisableSelection .cell .el-checkbox__inner {
    display: none;
    position: relative;
}

.el-table .DisableSelection .cell:before {
    content: "";
    position: absolute;
}

/deep/ .el-table__header .el-checkbox {
    //找到表头，然后隐藏掉复选框
    display: none;
}</style>
  